import React from 'react';
import { Container, Segment, Grid, Image, Header } from 'semantic-ui-react';

const Contact = () => (
	<Segment basic>
		<Container>
			<Grid stackable>
				<Grid.Row>
					<Grid.Column width={10}>
						<Image src='/assets/images/roselandlogo.jpg' centered/>
					</Grid.Column>
					<Grid.Column width={6} verticalAlign="middle">
						<Header content="Contact Details:"/>
						<p>
							Dr. J. Whetter<br/>
							The Roseland Institute<br/>
							Gorran<br/>
							St Austell<br/>
							Cornwall<br/>
							PL26 6NT
						</p>
						<p>Tel.\Fax. 01726 843501</p>
						<p>Email <a href="trelispen@gmail.com">trelispen@gmail.com</a></p>
						<p>To purchase a book or place a subscription (Annual post subscription - inland £15.00, surface overseas £20.00, airmail £25.00) to the Cornish Banner please send a cheque to the above address.</p>
						<p>Prices listed include P&P.</p>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Container>
	</Segment>
)

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js